/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    declare type SidebarSecondaryToggleDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                             $window: ng.IWindowService,
                                                             $timeout: ng.ITimeoutService) => SidebarSecondaryToggleDirective;

    interface ISidebarSecondaryToggleDirectiveScope extends ng.IScope {
        toggleSecondarySidebar: ($event: ng.IAngularEvent) => void;
    }

    interface IMyEvent extends Event {
        which?: number;
    }

    export class SidebarSecondaryToggleDirective implements ng.IDirective {
        public static $name: string = 'sidebarSecondaryToggle';

        public link: ($scope: ISidebarSecondaryToggleDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public replace: boolean = true;
        public template: string = `<a id="sidebar_secondary_toggle" class="sSwitch sSwitch_right"
                                    ng-click="toggleSecondarySidebar($event)" ng-show="sidebarSecondary">
                                        <span class="sSwitchIcon"></span>
                                   </a>`;

        /**
         * Factory for the directive
         */
        public static Factory(): SidebarSecondaryToggleDirectiveFactoryCb {
            let directive: SidebarSecondaryToggleDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                                       $window: ng.IWindowService,
                                                                       $timeout: ng.ITimeoutService) => {
                return new SidebarSecondaryToggleDirective($rootScope, $window, $timeout);
            };
            directive.$inject = ['$rootScope', '$window', '$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService) {

            SidebarSecondaryToggleDirective.prototype.link = ($scope: ISidebarSecondaryToggleDirectiveScope,
                                                              $element: JQuery,
                                                              attrs: ng.IAttributes) => {
                $scope.toggleSecondarySidebar = ($event: ng.IAngularEvent) => {
                    $event.preventDefault();
                    if (!$rootScope.secondarySidebarActive) {
                        $timeout(() => {
                            $rootScope.secondarySidebarActive = true;
                        }, 190);
                    } else {
                        $rootScope.secondarySidebarActive = false;
                    }
                };
            };
        }
    }
}